import React from "react";
import RemoteSelect2 from "./remoteSelect2";

export const PRODUCT_TYPE_PAGE_SIZE = 2000;
export const PRODUCT_TYPE_DROPDOWN_HEIGHT = 480;

export const productTypeCategoryId = (category) => {
  if (!category) return null;
  if (typeof category === "string" || typeof category === "number") {
    return String(category);
  }
  return category._id ? String(category._id) : null;
};

export const productTypeSearchQuery = (category) => {
  const categoryId = productTypeCategoryId(category);
  if (!categoryId) return { _id: { $in: [] } };
  return { category: categoryId };
};

export const clearProductTypeWhenCategoryChanges = (_selected, form) => {
  if (!form?.setFieldValue || !form.values?.type) return;
  form.setFieldValue("type", null);
};

const ProductTypeSelect = ({ form, name = "type", placeholder, ...props }) => {
  const categoryId = productTypeCategoryId(form?.values?.category);

  return (
    <RemoteSelect2
      valueField="_id"
      labelField="name"
      searchFields={["name", "code", "cname"]}
      sort={{ by: "name", order: "asc" }}
      {...props}
      form={form}
      name={name}
      apiEntity="productType"
      pageSize={PRODUCT_TYPE_PAGE_SIZE}
      maxDropdownHeight={PRODUCT_TYPE_DROPDOWN_HEIGHT}
      preQuery={productTypeSearchQuery(form?.values?.category)}
      placeholder={categoryId ? placeholder || undefined : "Select category first"}
    />
  );
};

export default ProductTypeSelect;
